import React from 'react';
import { Link } from 'react-router-dom';

export default function PageHeader({ title, breadcrumbs, action }) {
  return (
    <div className="mb-5 sm:mb-6">
      {breadcrumbs && breadcrumbs.length > 0 && (
        <nav className="wss-breadcrumb mb-2 text-xs sm:text-sm flex items-center flex-wrap gap-1" aria-label="Breadcrumb">
          {breadcrumbs.map((crumb, index) => {
            const isHome = crumb.label?.toLowerCase() === 'home' || crumb.href === '/';
            return (
              <React.Fragment key={crumb.label || index}>
                {index > 0 && <span className="mx-1 text-gray-400">/</span>}
                {crumb.href ? (
                  <Link
                    to={crumb.href}
                    className="text-gray-600 hover:text-[#003087] hover:underline font-medium transition-colors"
                  >
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="text-gray-700 font-medium">{crumb.label}</span>
                )}
              </React.Fragment>
            );
          })}
        </nav>
      )}
      <div className="flex items-start justify-between gap-3">
        <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900">{title}</h1>
        {action}
      </div>
    </div>
  );
}
